import script from "./new_stack_p4_A.vue?vue&type=script&setup=true&lang=js"
export * from "./new_stack_p4_A.vue?vue&type=script&setup=true&lang=js"

import "./new_stack_p4_A.vue?vue&type=style&index=0&id=2a6bceee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6bceee"]])

export default __exports__